import React from "react";
import { PageType } from ".";
interface PlusEssentialsPhase3AdProps {
  name: string;
  dollarAmountSaved: number;
  backgroundImage: string;
  couponCode: string;
  endDate: string;
  link: string;
  mobileBackgroundImage: string;
  trackingName: string;
  pageType: PageType;
}
const PlusEssentialsPhase3Ad = ({
  name,
  dollarAmountSaved,
  backgroundImage,
  couponCode,
  endDate,
  link,
  mobileBackgroundImage,
  trackingName,
  pageType
}: PlusEssentialsPhase3AdProps) => {
  const isHomepage = pageType === "Home";
  return <div className="h-fit" data-sentry-component="PlusEssentialsPhase3Ad" data-sentry-source-file="PlusEssentialsPhase3Ad.tsx">
      <a href={link} className={trackingName} id={`${trackingName}-3`} data-testid={`${trackingName}-3`}>
        <div className="mx-auto
                    mt-8
                    mb-2
                    relative
                    overflow-hidden
                    rounded
                    bg-[#06142B]
                    flex
                    flex-col
                    xs:flex-row
                    justify-between">
          <div className={`relative z-10 ${isHomepage ? "" : "pr-[70px]"}`}>
            <div className={`pt-6
                        px-6
                        pb-0
                        xs:pb-6
                        ${isHomepage ? "xs:pr-0 md:pr-0 lt:pr-0" : "xs:pr-6 md:pr-10 lt:pr-8"}
                        md:p-[28px]
                        lt:p-8
                        `}>
              <div className="w-full
                          text-center
                          xs:text-left
                          flex
                          flex-col
                          items-center
                          xs:items-start">
                <h3 data-testid={`${trackingName}-3-headline`} className="text-white
                            font-bold
                            text-2xl
                            xsl:text-[28px]
                            leading-none
                            xs:text-3xl
                            xs:leading-none
                            lt:text-[42px]
                            lt:leading-[38px]
                            mb-2
                            mx-0
                            text-wrap
                            w-[260px]
                            xsl:w-[350px]
                            lt:w-[450px]">
                  You have ${dollarAmountSaved} FREE towards the{" "}
                  {name.toLowerCase()}!
                </h3>
                <p className={`text-base
                  leading-[20px]
                  md:text-lg
                  md:leading-[22px]
                  font-normal
                  text-white
                  text-wrap
                  w-[350px]
                  ${isHomepage ? "xsl:w-[450px]" : "xsl:w-[410px]"}
                  mb-6`}>
                  <span>
                    Save on everyday {name.toLowerCase()} like toilet paper,
                    take-out containers, flavoring syrups, and so much more!
                  </span>
                </p>
                <div className="flex flex-col xs:flex-row items-center gap-x-4">
                  <span className="bg-[#3DCAFF]
                              hover:bg-[#37B7E6]
                              text-[#06142B]
                              font-semibold
                              px-6
                              py-2
                              rounded
                              text-xs
                              sm:text-sm
                              md:text-base
                              whitespace-nowrap">
                    Use Code: {couponCode}
                  </span>
                  <div className="flex
                              flex-col
                              mt-4
                              text-white
                              items-center
                              justify-center
                              sm:items-start
                              xs:mt-0">
                    <span className="text-sm font-bold leading-[15px]">
                      Offer ends {endDate}
                    </span>
                    <span className="text-xs font-normal">
                      Limited Time, Single Use Code
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="relative
                      w-full
                      xs:w-1/2
                      lt:w-2/5
                      xl:w-1/2
                      z-10
                      overflow-visible
                      mt-0">
            <img className="block xs:hidden w-full" src={mobileBackgroundImage} alt="" />
            <img className="absolute
                        z-0
                        hidden
                        xs:block
                        aspect-auto
                        object-cover
                        object-left
                        h-full
                        w-full" src={backgroundImage} alt="" />
          </div>
        </div>
      </a>
    </div>;
};
export default React.memo(PlusEssentialsPhase3Ad);